module.exports = __webpack_public_path__ + "static/media/testimonial_9.2abcc892.jpg";